function fetchDraftOrder(draft_order_id) {
  //   console.log("fetching", draft_order_id);
  return fetch(
    `https://webhooks.mechanic.dev/616866a2-dc88-4e81-869e-3d3d4f538d9c`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        draft_order_id: draft_order_id,
      }),
    }
  )
    .then((response) => {
      //   console.log(response);
      //   now fetch the cache
      return fetch(
        `https://usemechanic.com/cache/b13ec06f-d516-4454-b965-7559e212815f`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          // console.log("fetched cache");
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

async function addToProjectAction(draft_order_id, targetButton) {
  const myCart = document.querySelector("cart-drawer");
  return fetchDraftOrder(draft_order_id).then((response) => {
    var items = [];
    // console.log(response);
    if (response) {
      var responseItems = response["d_" + draft_order_id];
      if (responseItems) {
        responseItems = JSON.parse(responseItems);
        for (item in responseItems) {
          const { variant_id, price, properties, quantity } =
            responseItems[item];
          const propertiesObj = {};
          properties.forEach((property) => {
            propertiesObj[property.name] = property.value;
          });
          propertiesObj.variant_id = variant_id;
          //   console.log(myCart, variant_id, price, properties, propertiesObj);
          items.push({
            quantity,
            id: variant_id,
            price: propertiesObj.price,
            image: propertiesObj["variant image"],
            properties: propertiesObj,
          });
        }
        return fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: items,
            sections: "cart-drawer,cart-icon-bubble",
          }),
        })
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            myCart.renderContents(response);
            myCart.classList.remove("is-empty");
            return { targetButton, response };
          })
          .catch((error) => {
            console.error("Error:", error);
            // location.reload();
            // TODO: open the cart drawer
          });
      } else {
        // console.log("fetched but no matching draft order");
        // console.log(response);
        return new Promise(resolve => {
          setTimeout(() => {
            resolve(addToProjectAction(draft_order_id, targetButton));
          }, 2000);
        });
      }
      return { targetButton, response };
    }
  });
}

class AddToProjectButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      // console.log(event.target);
      let targetButton = event.target;
      while (targetButton.nodeName.toLowerCase() !== "button") {
        targetButton = targetButton.parentElement;
      }
      // console.log(targetButton);
      if (targetButton.classList.contains("loading")) {
        // console.log("already loading");
        return;
      }
      targetButton.classList.add("loading");
      // console.log(targetButton.dataset.order);
      addToProjectAction(targetButton.dataset.order, targetButton)
        .then((response) => {
          if (typeof response === "undefined") {
            // console.log("undefined response");
            // console.log(response, event);
          }
          response?.targetButton?.classList.remove("loading");
        })
        .catch((error) => {
          console.error("Error:", error);
          // console.log(event);
          targetButton.classList.remove("loading");
          // debugger;
          // location.reload();
          // TODO: open the cart drawer
        });
    });
  }
}

customElements.define("add-to-project-btn", AddToProjectButton);
